module.exports = __webpack_public_path__ + "img/j.5e348fb4.png";